import { render, staticRenderFns } from "./Fallback1Icon.vue?vue&type=template&id=524167a8&"
import script from "./Fallback1Icon.vue?vue&type=script&lang=js&"
export * from "./Fallback1Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports